import { Component, Input, Output, EventEmitter, AfterViewInit, OnDestroy } from '@angular/core';

import { fromEvent, interval, race, Subject } from 'rxjs';
import { tap, takeUntil, switchMap } from 'rxjs/operators';

@Component({
    selector: 'aa-scroll-menu',
    templateUrl: './scroll-menu.component.html',
    styleUrls: [
        './scroll-menu.component.scss'
    ],
    standalone: false
})
export class ScrollMenuComponent implements AfterViewInit, OnDestroy
{
    @Input() icon: string;
    @Input() id: string;
    @Output() scroll: EventEmitter<never> = new EventEmitter<never>();
    private destroyator = new Subject();

    constructor()
    {
    }

    ngAfterViewInit (): void
    {
        const button = document.getElementById(this.id);
        const notifier = race([fromEvent(button, 'mouseup'), fromEvent(button, 'mouseleave')]);

        fromEvent(button, 'mousedown')
            .pipe(
                switchMap(() =>
                    interval(200)
                        .pipe(
                            tap(() => this.scroll.emit()),
                            takeUntil(notifier)
                        )
                ),
                takeUntil(this.destroyator)
            )
            .subscribe();
        fromEvent(button, 'click')
            .pipe(
                tap(() => this.scroll.emit()),
                takeUntil(this.destroyator)
            )
            .subscribe();
    }

    ngOnDestroy ()
    {
        this.destroyator.next(null);
        this.destroyator.complete();
    }
}
